"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const AltText = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { d: "M3.472 7 0 16h2.36l.637-1.744h3.31L6.958 16h2.419L5.906 7H3.472ZM4.66 9.785l.935 2.536h-1.87l.935-2.536ZM10.171 16h6.47v-2.037h-4.08V7h-2.39v9Zm5.816-6.977h2.805V16h2.389V9.023H24V7h-8.013v2.023Z" })
  );
};
export default AltText;
